import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e6664260"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-wrapper" }
const _hoisted_2 = { class: "scrollable-content" }
const _hoisted_3 = { class: "info-section" }
const _hoisted_4 = { class: "invoice-header" }
const _hoisted_5 = { class: "invoice-icon" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invoice-details" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "invoice-title" }, "Send Invoices"),
  /*#__PURE__*/_createElementVNode("div", { class: "invoice-subtitle" }, "Export & Send")
], -1))
const _hoisted_7 = { class: "form-section" }
const _hoisted_8 = { class: "form-card" }
const _hoisted_9 = { class: "date-selector" }
const _hoisted_10 = { class: "date-item" }
const _hoisted_11 = { class: "date-input-wrapper" }
const _hoisted_12 = { class: "date-item" }
const _hoisted_13 = { class: "date-input-wrapper" }
const _hoisted_14 = { class: "action-section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_ion_datetime_button = _resolveComponent("ion-datetime-button")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_datetime = _resolveComponent("ion-datetime")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createBlock(_component_ion_content, { class: "text-selectable modal-content" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_font_awesome_icon, { icon: ['fas', 'paper-plane'] })
              ]),
              _hoisted_6
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("h4", null, _toDisplayString(_ctx.t("settings-page.from-date")), 1),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_ion_datetime_button, { datetime: "datetimeFrom" })
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("h4", null, _toDisplayString(_ctx.t("settings-page.to-date")), 1),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_ion_datetime_button, { datetime: "datetimeTo" })
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_ion_button, {
            expand: "block",
            size: "large",
            class: "primary-action",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onSend())),
            disabled: _ctx.sendInProgress
          }, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, {
                icon: ['fas', 'paper-plane'],
                class: "button-icon"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.t("common.send")), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _createVNode(_component_ion_modal, { "keep-contents-mounted": true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_datetime, {
            id: "datetimeFrom",
            "show-default-buttons": true,
            presentation: "date",
            modelValue: _ctx.form.startDate,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.startDate) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_modal, { "keep-contents-mounted": true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_datetime, {
            id: "datetimeTo",
            "show-default-buttons": true,
            presentation: "date",
            modelValue: _ctx.form.endDate,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.endDate) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}